import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserSupplierService } from '../../../../Services/User/Supplier/user-supplier.service';
import { NotificationService } from '../../../../Services/notification.service';

@Component({
  selector: 'app-staff-reset-password',
  imports: [FormsModule],
  templateUrl: './staff-reset-password.component.html',
  styleUrl: './staff-reset-password.component.css'
})
export class StaffResetPasswordComponent implements OnChanges{

  @Input() staffData: any;   // ✅ not array

  email: string = '';
  password: string = '';
  master_password: string = '';

  constructor(private userSupplierService:UserSupplierService,private notification:NotificationService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['staffData'] && this.staffData) {
      console.log("staff data", this.staffData);
      this.email = this.staffData?.email;
    }
  }

  updatePassword() {

    const formData = new FormData();

    formData.append('email', this.email);
    formData.append('password', this.password);
    formData.append('master_password', this.master_password);

    // 👇 IMPORTANT
    formData.append('_method', 'PUT');

    this.userSupplierService
      .updateUserSupplier(this.staffData.id, formData)
      .subscribe((res: any) => {
        this.notification.showSuccess(
          "Password updated successfully",
          "success"
        );
      });
  }
}
